(function () {
var $5fbffa87c50562b9$exports = {};
let $5fbffa87c50562b9$var$onLoad = ()=>{
    const illustration = document.getElementById("illustration");
    illustration.style.visibility = "visible";
    let sheep = document.getElementsByClassName("sheep")[0];
    sheep.onanimationend = (e)=>{
        e.target.classList.remove("grow");
    };
    const growableElements = document.querySelectorAll("#illustration > img[data-grow]");
    growableElements.forEach((element)=>{
        element.classList.add("grow");
    });
    new Parallax(illustration);
};
window.addEventListener("load", $5fbffa87c50562b9$var$onLoad);

})();
//# sourceMappingURL=index.b53d403c.js.map
